import { render, staticRenderFns } from "./PendingComplaintsData.vue?vue&type=template&id=1e734d95"
import script from "./PendingComplaintsData.vue?vue&type=script&lang=js"
export * from "./PendingComplaintsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports